import { clsx } from 'clsx';
import { FC, Fragment, HTMLAttributes, useState } from 'react';
import { Image } from 'atoms/Image/Image';
import { Body } from 'atoms/Typography/Typography';
import { NextLink } from 'modules/i18n/navigation';
import { useTranslations } from 'modules/i18n/useTranslations';
import { Variant, VariantListProps } from './types';
import styles from './VariantLinkList.module.css';

export const VariantList: FC<VariantListProps> = ({
  variants,
  currentProductId,
  isLink = true,
  setActiveVariant,
  className,
}) => {
  const t = useTranslations();
  const sortedVariants = variants.sort((a, b) => a.href.localeCompare(b.href));
  const activeVariant = sortedVariants.find(
    (item) => item.id.toString() === currentProductId,
  );
  const [hovered, setHovered] = useState('');

  const renderImage = (product: Variant) => (
    <Image
      className={styles.colorImage}
      src={product.cover}
      alt={product.title}
    />
  );

  return (
    <div className={clsx(styles.variantColors, className)}>
      <Body type="sm" weight="medium" className={clsx(styles.colorText)}>
        {t('product.pdp.color')}:{' '}
        <Body
          type="sm"
          tag="span"
          weight="medium"
          className={styles.colorTitle}
        >
          {hovered || activeVariant?.title}
        </Body>
      </Body>
      <div className={clsx(styles.colorImages)}>
        {sortedVariants.map((variant) => {
          const isActive = variant.id.toString() === currentProductId;
          const imageProps: HTMLAttributes<HTMLElement> = {
            onMouseOver: () => setHovered(variant.title),
            onMouseLeave: () => setHovered(''),
            className: clsx(
              styles.imageWrapper,
              variant.isSoldOut && styles.crossed,
              isActive && styles.isActive,
              !isLink && setActiveVariant && styles.clickable,
            ),
            title: variant.title,
          };

          return (
            <Fragment key={variant.id || variant.referenceKey}>
              {isLink ? (
                <NextLink {...imageProps} href={variant.href}>
                  {renderImage(variant)}
                </NextLink>
              ) : (
                <span
                  {...imageProps}
                  onClick={() => setActiveVariant?.(variant.referenceKey)}
                >
                  {renderImage(variant)}
                </span>
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};
